import * as React from "react";

import { SelectableItemComponent } from "../selectableItem/selectableItem";
import { ISelectableItem } from "../selectableItem/selectableItemConverters";
import { ShadowScrollbar } from "../scrollbar/shadowScrollbar";

export enum Layout {
	Horizontal = 1,
	Vertical
}

export interface SelectableItemContainerProps {
	id: string;
	items: ISelectableItem[];
	selectedItem: ISelectableItem;
	uppercase: boolean;
	layout: Layout;
	onSelect?: any;
	contentCentered: boolean;
	contentCenteredVertical?: boolean;
	itemClassName?: string;
	colStyle?: string;
	itemTitleClassName?: string;
}

interface SelectableItemContainerState {
	selectedItem: ISelectableItem;
}

interface IScrollbarStyle {
	upperCase: string,
	textAlign: string,
	thumbBgHorizontal: string,
	thumbBgVertical: string,
	thumbThickness: string,
	bottomPositionHorizontal?: string,
	rightPositionVertical?: string,
}

export class SelectableItemContainer extends React.Component<SelectableItemContainerProps, SelectableItemContainerState> {
	constructor(props: SelectableItemContainerProps) {
		super(props);

		this.state = {
			selectedItem: this.props.selectedItem
		};

		this.toggleItem = this.toggleItem.bind(this);
		this.selectItemToState = this.selectItemToState.bind(this);
	}

	componentWillReceiveProps(nextProps: SelectableItemContainerProps) {
		if (nextProps.selectedItem !== this.props.selectedItem) {
			let selectedItem = nextProps.selectedItem;
			this.setState({
				selectedItem: selectedItem
			});
		}
	}

	private selectItemToState(selectedItem: ISelectableItem) {
		this.setState({
			...this.state,
			selectedItem,
		});
	}

	private toggleItem(item: ISelectableItem) {
		if (!item.selected) {
			this.props.items.forEach(actualItem => actualItem.selected = false);
			item.selected = true;
			this.selectItemToState(item);
		} else {
			item.selected = false;
			this.selectItemToState(null);
		}
	}

	private onClickItem(item: ISelectableItem): void {
		this.toggleItem(item);

		var selectedItem = item;
		if (!item.selected)
			selectedItem = null;

		this.props.onSelect instanceof Function && this.props.onSelect(selectedItem);
	}

	private renderHorizontalLayout(scrollStyle: IScrollbarStyle): JSX.Element {
		return (
			<div className={'d-sm-hidden selectable-item-container horizontal' + scrollStyle.upperCase + scrollStyle.textAlign}>
				<ShadowScrollbar id={'_horizontal_' + this.props.id}
					style={{ width: '100%', height: '100%' }}
					horizontalOnly={true}
					autoScrollSelected={true}
					renderThumbHorizontal={({ style, ...props }) => <div {...props} style={{ ...style, backgroundColor: scrollStyle.thumbBgHorizontal, height: scrollStyle.thumbThickness, bottom: scrollStyle.bottomPositionHorizontal }} />}
					renderThumbVertical={({ style, ...props }) => <div {...props} style={{ ...style, backgroundColor: scrollStyle.thumbBgVertical, width: scrollStyle.thumbThickness }} />}>

					<table className="horizontal-table">
						<tbody>
							<tr>
								<td className="horizontal-row">

									{
										this.props.items.map(item =>
											<SelectableItemComponent
												itemTitleClassName={this.props.itemTitleClassName}
												isDisabled={item.data.IsAvailable == false}
												itemClassName={this.props.itemClassName}
												imageClassName={item.imageClassName}
												onClick={() => this.onClickItem(item)}
												key={item.code}
												title={item.title}
												selected={this.state.selectedItem != null && item.code == this.state.selectedItem.code}
												imageUrl={item.imageUrl}
												code={item.code}
												description={item.description}
												data={item.data}
												colStyle="horizontal-item" />
										)
									}
								</td>
							</tr>
						</tbody>
					</table>
				</ShadowScrollbar>
			</div>
		);
	}

	private renderVerticalLayout(scrollStyle: IScrollbarStyle, classes: string = ''): JSX.Element {
		return (
			<div className={"selectable-item-container vertical" + scrollStyle.upperCase + scrollStyle.textAlign + ' ' + classes}>
				<ShadowScrollbar id={'_vertical_' + this.props.id}
					style={{ height: '100%' }}
					verticalOnly={true}
					autoScrollSelected={true}
					renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
					renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
					renderThumbVertical={({ style, ...props }) => <div {...props} style={
						{
							...style,
							backgroundColor: scrollStyle.thumbBgVertical,
							width: scrollStyle.thumbThickness,
							float: 'right',
							right: scrollStyle.rightPositionVertical,
							zIndex: 9
						}
					} />}>

					{
						this.props.contentCenteredVertical &&
						<table className="content-table">
							<tbody>
								<tr>
									<td>
										<div className="row selectable-items-row">
											{
												this.props.items.map(item => (
													<SelectableItemComponent
														isDisabled={item.data.IsAvailable == false}
														itemClassName={this.props.itemClassName}
														imageClassName={item.imageClassName}
														onClick={() => this.onClickItem(item)}
														key={item.code}
														title={item.title}
														selected={this.state.selectedItem != null && item.code == this.state.selectedItem.code}
														imageUrl={item.imageUrl}
														code={item.code}
														description={item.description}
														data={item.data}
														colStyle={this.props.colStyle ? this.props.colStyle : "selectable-item-col"} />
											))}
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					}

					{
						!this.props.contentCenteredVertical &&
						<div className="container">
							<div className="row selectable-items-row">
								{
									this.props.items.map(item => (
										<SelectableItemComponent
											isDisabled={item.data.IsAvailable == false}
											itemClassName={this.props.itemClassName}
											imageClassName={item.imageClassName}
											onClick={() => this.onClickItem(item)}
											key={item.code}
											title={item.title}
											selected={this.state.selectedItem != null && item.code == this.state.selectedItem.code}
											imageUrl={item.imageUrl}
											code={item.code}
											description={item.description}
											data={item.data}
											colStyle={this.props.colStyle ? this.props.colStyle : "selectable-item-col"} />
									))
								}
							</div>
						</div>
					}
				</ShadowScrollbar>
			</div>
		);
	}

	render() {
		let scrollStyle: IScrollbarStyle = {
			textAlign: this.props.contentCentered ? " text-center" : " text-left",
			upperCase: this.props.uppercase ? " uppercase" : "",
			thumbBgHorizontal: 'rgba(255,255,255,0.4)',
			thumbBgVertical: 'rgba(255,255,255,0.4)',
			thumbThickness: '2px',
			bottomPositionHorizontal: '12px',
			rightPositionVertical: '5px'
		};

		return (
			<div className={`selectable-item-main-container ${this.props.itemClassName}`}>
				{
					this.props.layout == Layout.Horizontal && this.renderHorizontalLayout(scrollStyle)
				}
				{
					this.props.layout == Layout.Horizontal && this.renderVerticalLayout(scrollStyle, 'visible-sm d-md-hidden')
				}
				{
					this.props.layout != Layout.Horizontal
					&& this.renderVerticalLayout(scrollStyle)
				}
			</div>
		);
	}
}

export default SelectableItemContainer;